import React from "react";
import "../styles/welcomebackModal.scss";

const WelcomebackModal = ({continue: continueSlide, startOver}) => {
  return (
    <div className="welcome_back_modal">
      <div className="container">
        <div className="modal">
          <div className="content">
            <p>
              Welcome back! It looks like you've already explored part of this
              interactive presentation. Our AI Representative, Lyra, is ready to
              continue guiding you through the remaining slides with insightful
              narration.
            </p>
            <p>
              Would you like to continue from where you left off, or start the
              experience from the beginning? Either way, Lyra is here to make
              your journey seamless and engaging.
            </p>
            <div className="btnGrp">
              <button onClick={startOver}>Start Over</button>
              <button onClick={continueSlide}>Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomebackModal;
